import {BaseService} from "./base.service";

class SupplierSpecialistService extends BaseService {

    constructor() {
        super('api/specialists');
    }

   /* getServiceBySupplierId(supplierId) {
        return this.http.get(`api/get-agent-by-promoter-id/${promoterId}`).then(response => response.data).catch(err => err.message);
    }*/
}

export const supplierspecialistService = new SupplierSpecialistService();
